module.exports = __webpack_public_path__ + "static/img/facebook.ca31a6d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/facebook.png
// module id = +ces
// module chunks = 1